import React from 'react'
import PropTypes from 'prop-types'

import { InputGroup } from './InputGroup'

export const FormControl = React.forwardRef(({ error, ...props }, ref) => {
  return (
    <React.Fragment>
      <InputGroup ref={ref} {...props} />
      {error && <span className="input-error is-visible">{error}</span>}
    </React.Fragment>
  )
})

FormControl.displayName = 'FormControl'

FormControl.propTypes = {
  error: PropTypes.string,
}
